<template>
  <div>
    <BrowserStorage />
    <h4>{{ $t('static_translation.reisedaten') }}</h4>
    <ErrorContainer
      :section-errors="errors.items"
      type="journey"
    />
    <div class="uk-grid uk-grid-medium">
      <div class="uk-width-1-2@m uk-width-1-2@l uk-width-1-2@xl uk-width-1-1@s">
        <h5>{{ $t('static_translation.an-und-abreise') }}
          <span style="text-transform: uppercase;">({{ pickerDateFormat }})</span>
          <span class="requiredFileds" />
        </h5>
        <div class="uk-grid uk-grid-small">
          <div class="uk-width-1-2">
            <FormItem
              :class="{'ivu-form-item-error': errors.has('arrival_at') }"
            >
              <DatePicker
                v-validate:arrival_at="{required: true, after: yesterday, date_format: 'dd.MM.yyyy'}"
                ref="arrivalAtCheck"
                :placeholder="$t('static_translation.ankunft')"
                :data-vv-as="arrivalName"
                :options="arrivalOptions"
                :format="pickerDateFormat"
                v-model="arrival_at"
                data-vv-name="arrival_at"
                autofocus="autofocus"
                @on-change="arrivalChange"
              />
            </FormItem>
          </div>
          <div class="uk-width-1-2" >
            <FormItem
              :class="{'ivu-form-item-error': errors.has('departure_at') }"
            >
              <DatePicker
                v-validate:departure_at="{required: true, after: 'arrivalAtCheck', date_format: 'dd.MM.yyyy'}"
                v-model="departure_at"
                :data-vv-as="departureName"
                :placeholder="$t('static_translation.abreise')"
                :options="departureOptions"
                :format="pickerDateFormat"
                data-vv-name="departure_at"
                type="date"
              />
            </FormItem>
          </div>
        </div>
      </div>

      <div class="uk-width-1-2@m uk-width-1-2@l uk-width-1-2@xl uk-width-1-1@s">
        <div class="uk-hidden@m uk-hidden@l uk-hidden@xl"><br></div>
        <h5>{{ $t('static_translation.anzahl-der-personen') }} ({{ $t('static_translation.erwachsene') }}, {{ $t('static_translation.kinder') }})
          <span class="requiredFileds" />
        </h5>
        <div class="uk-grid uk-grid-small">
          <div class="uk-width-1-4">
            <FormItem
              :class="{'ivu-form-item-error': errors.has('adults') }"
              style="width:100%;"
            >
              <InputNumber
                v-validate="'required:true|min_value:1'"
                v-model.trim="adults"
                :placeholder="$t('static_translation.erwachsene')"
                :min="0"
                data-vv-name="adults"
                data-vv-as="Erw"
                style="width:100%;"
              />
            </FormItem>
          </div>
          <div class="uk-width-1-4">
            <FormItem style="width:100%;">
              <InputNumber
                v-model.trim="childs"
                :min="0"
                :placeholder="$t('static_translation.kinder')"
                style="width:100%;"

              />
            </FormItem>
          </div>
          <div class="uk-width-1-2">
            <FormItem style="width:100%;">
              <Input
                v-validate:age_of_childs="ageOfChildsValidation"
                v-model.trim="age_of_childs"
                :placeholder="$t('static_translation.alter-der-kinder')"
                :data-vv-as="$t('static_translation.alter-der-kinder')"
                :class="{'ivu-form-item-error': errors.has('age_of_childs') }"
                data-vv-name="age_of_childs"
                style="width:100%;"
              >
              </Input>
            </FormItem>
          </div>
        </div>
      </div>
    </div>
    <h4> {{ $t('static_translation.kontaktdaten') }} </h4>
    <ErrorContainer
      :section-errors="errors.items"
      type="contact"
    />
    <div class="uk-grid uk-grid-medium">
      <div class="uk-width-1-2@m uk-width-1-2@l uk-width-1-2@xl uk-width-1-1@s">
        <h5>{{ $t('static_translation.name-und-email') }}
          <span class="requiredFileds" />
        </h5>
        <div class="uk-grid uk-grid-small">
          <div class="uk-width-1-3">
            <FormItem prop="salutation_id">
              <Select
                v-validate:salutation_id="{required: true}"
                v-model="salutation_id"
                :placeholder="$t('static_translation.anrede')"
                :data-vv-as="salutationName"
                :auto-complete="false"
                :class="{'ivu-form-item-error': errors.has('salutation_id') }"
                style="font-weight:bold;"
                data-vv-name="salutation_id"
              >

                <Option
                  v-for="(item, key) in translatedSalutations"
                  :key="key"
                  :value="parseInt(key)"
                >{{ item }}</Option>
              </Select>
            </FormItem>
          </div>
          <div class="uk-width-2-3">
            <FormItem
              v-if="salutation_id !== 1"
            >
              <Input
                v-validate:first_name="firstNameValidation"
                v-model.trim="first_name"
                :placeholder="$t('static_translation.vorname')"
                :data-vv-as="firstNameName"
                :class="{'ivu-form-item-error': errors.has('first_name') }"
                data-vv-name="first_name"
              ></Input>
            </FormItem>
          </div>
          <div class="uk-width-1-1">
            <FormItem>
              <Input
                v-validate:last_name="{required: true}"
                v-model.trim="last_name"
                :data-vv-as="nameName"
                :class="{'ivu-form-item-error': errors.has('last_name') }"
                :placeholder="$t('static_translation.name')"
                data-vv-name="last_name"
              ></Input>
            </FormItem>
          </div>
          <div class="uk-width-1-1">
            <FormItem prop="mail">
              <Input
                v-validate:mail="{required: true, email: true}"
                :data-vv-as="mailName"
                v-model.trim="mail"
                :class="{'ivu-form-item-error': errors.has('mail') }"
                :placeholder="$t('static_translation.e-mail')"
                data-vv-name="mail"
              ></Input>
            </FormItem>
          </div>
          <div class="uk-width-1-1 uk-margin-small-top">
            <h5>{{ $t('static_translation.land') }}
              <span class="requiredFileds" />
            </h5>
            <FormItem>
              <Select
                v-validate:country_id="{required: true}"
                v-model="country_id"
                :data-vv-as="countryName"
                :class="{'ivu-form-item-error': errors.has('country_id') }"
                style="font-weight:600;"
                data-vv-name="country_id"
                clearable
              >
                <Option
                  v-for="country in countries"
                  :key="country.id"
                  :value="country.id"
                >{{ country.name }}</Option>
              </Select>
            </FormItem>
          </div>
        </div>
      </div>
      <div class="uk-width-1-2@m uk-width-1-2@l uk-width-1-2@xl uk-width-1-1@s">
        <div class="uk-hidden@m uk-hidden@l uk-hidden@xl"><br></div>
        <h5>{{ $t('static_translation.anschrift-und-telefon') }} </h5>
        <div class="uk-grid uk-grid-small">
          <div class="uk-width-1-1">
            <FormItem>
              <Input
                v-model.trim="street"
                :placeholder="$t('static_translation.strasse')"
              ></Input>
            </FormItem>
          </div>
          <div class="uk-width-1-3">
            <FormItem>
              <Input
                v-model.trim="zip"
                :placeholder="$t('static_translation.plz')"
              ></Input>
            </FormItem>
          </div>
          <div class="uk-width-2-3">
            <FormItem>
              <Input
                v-model.trim="city"
                :placeholder="$t('static_translation.ort')"
              ></Input>
            </FormItem>
          </div>
          <div class="uk-width-1-1">
            <FormItem>
              <Input
                v-model.trim="phone"
                :data-vv-as="phoneName"
                :class="{'ivu-form-item-error': errors.has('phone') }"
                :placeholder="$t('static_translation.telefon')"
              ></Input>
            </FormItem>
          </div>
        </div>
      </div>
      <div
        v-if="type === 5 && offer"
        class="uk-width-1-1"
      >
        <h4
          class="uk-margin-small-top"
        >
          Angaben zum Angebot {{ offer.name }}
        </h4>
        <ErrorContainer
          :section-errors="errors.items"
          type="unit"
        />
        <div class="uk-grid uk-grid-small">
          <div class="uk-width-1-1">
            <FormItem
              :required="true"
              label="Gewünschte Unterkunftseinheit:"
            >
              <Select
                v-validate:unit_id="{required: true}"
                v-model="unit_id"
                :auto-complete="false"
                :class="{'ivu-form-item-error': errors.has('unit_id') }"
                placeholder="Gewünschte Unterkunftseinheit"
                data-vv-as="Unterkunftseinheit"
                data-vv-name="unit_id"
                style="font-weight:bold;"
              >
                <Option
                  v-for="unit in offer.units"
                  :key="unit.id"
                  :value="unit.id"
                >{{ unit.name }} ({{ unit.category }}) </Option>
              </Select>
            </FormItem>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapState,
  mapGetters
} from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import moment from 'moment'
import sugar from 'sugar'
import BrowserStorage from './BrowserStorage'
import 'sugar/locales'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  components: {
    BrowserStorage
  },
  data () {
    return {
      arrivalOptions: {
        disabledDate: date => {
          return date && sugar.Date.create('yesterday') >= date
        }
      },
      departureOptions: {
        disabledDate: date => {
          return date && sugar.Date.create(this.arrival_at) >= date
        }
      }
    }
  },
  computed: {
    ...mapState({
      salutations: state => state.store.salutations,
      offer: state => state.store.offer,
      inquiry: state => state.store.inquiry
    }),
    ...mapGetters({
      countries: 'getCountries'
    }),
    ...mapFields([
      'inquiry.arrival_at',
      'inquiry.departure_at',
      'inquiry.adults',
      'inquiry.childs',
      'inquiry.type',
      'inquiry.age_of_childs',
      'inquiry.salutation_id',
      'inquiry.last_name',
      'inquiry.first_name',
      'inquiry.street',
      'inquiry.zip',
      'inquiry.city',
      'inquiry.country_id',
      'inquiry.mail',
      'inquiry.phone',
      'inquiry.unit_id'
    ]),
    translatedSalutations () {
      const salutations = {}
      for (let [key, value] of Object.entries(this.salutations)) {
        salutations[key] = this.$t('salutation.' + key)
      }
      return salutations
    },
    firstNameValidation () {
      return { required: (this.salutation_id >= 3) }
    },
    ageOfChildsValidation () {
      return { required: (this.childs >= 1) }
    },
    pickerDateFormat () {
      return 'dd.MM.yyyy'
    },
    arrivalName () {
      return this.$t('static_translation.ankunft')
    },
    departureName () {
      return this.$t('static_translation.abreise')
    },
    salutationName () {
      return this.$t('static_translation.anrede')
    },
    firstNameName () {
      return this.$t('static_translation.vorname')
    },
    nameName () {
      return this.$t('static_translation.name')
    },
    countryName () {
      return this.$t('static_translation.land')
    },
    mailName () {
      return this.$t('static_translation.e-mail')
    },
    phoneName () {
      return this.$t('static_translation.telefon')
    },
    yesterday () {
      return moment().subtract(1, 'days').format('DD.MM.YYYY')
    }
  },
  mounted () {
    this.$validator.reset()
    this.$bus.$on('validate-data', async (page) => {
      if (page === 'Home') {
        const result = await this.$validator.validateAll()
        if (result) {
          this.$emit('on-validated', page)
        }
      }
    })
  },
  methods: {
    arrivalChange (date) {
      const momDate = moment(this.departure_at, 'DD.MM.YYYY')
      if (momDate.isValid()) return

      const sugarDate = new sugar.Date(this.departure_at, 'de')
      sugarDate.addDays(1)
      const departureDate = new sugar.Date(date, 'de').addDays(1)
      this.$store.commit('updateInquiry', {
        name: 'departure_at',
        value: departureDate.raw
      })
    },
    departureChange (date) {
      if (!date) return date
      const newDate = sugar.Date.create(date, 'de')
      this.$store.commit('updateInquiry', {
        name: 'departure_at',
        value: sugar.Date.format(newDate, '%Y-%m-%d')
      })
      return this.inquiry.departure_at
    }
  }
}
</script>
